import { makeStyles } from '@material-ui/core'

const styles = makeStyles(() => ({
  root: {
    height: ({ height }) => height,
    maxHeight: ({ maxHeight }) => maxHeight || undefined,
    overflowY: ({ axis }) => (axis === 'x' ? 'hidden' : 'auto'),
    overflowX: ({ axis }) => (axis === 'y' ? 'hidden' : 'auto'),
    '&::-webkit-scrollbar': {
      width: ({ axis, thickness }) => (axis === 'x' ? 0 : thickness),
      height: ({ axis, thickness }) => (axis === 'y' ? 0 : thickness),
    },
    '&::-webkit-scrollbar-track': {
      background: ({ trackColor }) => trackColor,
      borderRadius: ({ thumbRadius }) => thumbRadius,
    },
    '&::-webkit-scrollbar-thumb': {
      background: ({ autoHide, thumbColor }) =>
        autoHide ? 'transparent' : thumbColor,
      borderRadius: ({ thumbRadius }) => thumbRadius,
    },
    '&:hover::-webkit-scrollbar-thumb': {
      background: ({ autoHide, thumbColor, thumbColorHover }) =>
        autoHide ? thumbColor : thumbColorHover,
    },
    scrollbarWidth: ({ thickness }) => (thickness <= 6 ? 'thin' : 'auto'),
    scrollbarColor: ({ thumbColor, trackColor }) =>
      `${thumbColor} ${trackColor}`,
  },
}))

export default styles
